import {useDispatch} from "react-redux";
import {IOfferValue, SET_OFFER} from "@/store/slices/offerSlice";
import Digital from "@/layouts/Digital";
import Impresso from "@/layouts/Impresso";
import PrePago from "@/layouts/PrePago";
import Cortesia from "@/layouts/Cortesia";
import {NextPageContext} from "next";
import {useEffect, useState} from "react";
import {IOfferLoad, SET_LEAD_OFFER_LOAD} from "@/store/slices/leadSlice";
import * as crypto from "crypto";
import Apm from "@/utils/Apm";
import {setTransacaoId} from "@/utils/transacaoContext";
import Events from "@/utils/Events";
import {getOffer} from "@/api/offer";
import {SET_LOADING} from "@/store/slices/appSlice";
const requestIp = require('request-ip');
import { notFound } from "next/navigation";
import OfertaEsgotada from "@/components/OfertaEsgotada";

interface ICheckoutShowProps {
    oferta: IOfferValue | IOfferLoad,
    ofertaEsgotada?: boolean
}

const CheckoutShow = (props: ICheckoutShowProps) => {
    const {oferta, ofertaEsgotada} = props;

    if (ofertaEsgotada) {
        return <OfertaEsgotada/>
    }

    if (!oferta) {
        return notFound()
    }

    const instanceOfIOfferValue = (object: any): object is IOfferValue => {
        return 'loading' in object &&
            'loaded' in object ||
            'offer_type' in object
    }

    const hasOfferType = (object: any): boolean => {
        return !!object.offer_type
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [tipo_oferta, setOferta] = useState<string | undefined>(undefined);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const dispatch = useDispatch();
    dispatch(SET_LEAD_OFFER_LOAD(oferta))
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        let of: any = oferta

        if (of.id) {
            !of.id_transacao && (of.id_transacao = crypto.createHash('md5').update((Math.random() + 1).toString(36).substring(2) + Date.now() + of.id).digest('hex'));
        } else {
            Apm.captureError('Erro no arquivo pages/checkout/[path].tsx oferta não tinha a propriedade id')
        }

        Events.sendHotjarEvent("id_transacao_" + of.id_transacao);

        if (instanceOfIOfferValue(oferta) && oferta.id_transacao && oferta.cd_oferta) {
            setTransacaoId(String(oferta.id_transacao));
            Apm.addLabels({
                id_transacao: oferta.id_transacao,
                cd_oferta: oferta.cd_oferta
            });
        } else {
            Apm.captureError('Erro no arquivo pages/checkout/[path].tsx oferta não estava no formato exigido, valor da oferta: ' + JSON.stringify(oferta))
        }

        if (hasOfferType(oferta)) {
            setOferta((oferta as any).offer_type)
        }


        dispatch(SET_OFFER(oferta as IOfferValue))

    }, [oferta, dispatch]);

    if (tipo_oferta) {
        dispatch(SET_LOADING(false));
        switch (tipo_oferta) {
            case "digital_completa":
            case "digital_basica":
                if (instanceOfIOfferValue(oferta)) {
                    if (oferta.is_cortesia) {
                        return <Cortesia></Cortesia>
                    }
                    if (oferta.has_partner) {
                        return <PrePago></PrePago>
                    }
                } else {
                    Apm.captureError('Erro no arquivo pages/checkout/[path].tsx oferta não era do tipo IOfferValue')
                }
                return <Digital/>
            case "impresso_digital":
                return <Impresso/>
            case 'prepago':
                return <PrePago/>
        }
    }
}

const Checkout = (props: ICheckoutShowProps) => {
    return CheckoutShow(props);
}

export const getServerSideProps = (ctx: NextPageContext) => {
    const path = ctx.query.hasOwnProperty('path') ? ctx.query.path : false;

    if (path) {
        console.log('Pipeline: ' + process?.env?.pipeline)
        if (typeof path === 'string') {
            return getOffer(
                path,
                ctx.req?.headers["user-agent"] ?? '',
                `${ctx.req?.headers?.host}${ctx.req?.url}`?? '',
                ctx.req?.headers.referer ?? '',
                requestIp.getClientIp(ctx.req) || ''
            ).then((data) => {
                return {props: {oferta: data}}
            }).catch((err) => {
                Apm.captureError(`Checkout.getInitialProps() -> fail: ${path}`);
                Apm.captureError(err)

                if (err?.response?.status === 410) {
                    if (ctx.res) ctx.res.statusCode = 410;
                    return {props: {oferta: null, ofertaEsgotada: true}}
                }

                return {notFound: true}
            })
        } else {
            Apm.captureError("PATH NÃO ERA DO TIPO STRING EM [path].tsx")
        }
    }
    return {notFound: true}
};

export default Checkout
